// export const ODATA_BASE_URL = process.env.REACT_APP_API_ODATA_URL;
export const API_BASE_URL = window._env_.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

// export function requestUrl(url) {
//   var ret = ODATA_BASE_URL + url;
//   return ret;
// }

export function requestApi(url) {
  var ret = API_BASE_URL + url;
  return ret;
}

export function handleJsonResponse(response) {

  if (response.status === 200 || response.status === 204) {
    return response.status === 204 ? null : response.data;
  } else {
    if (response.status === 400) {
      throw new Error(response.text());
    }
    if ([401, 403].indexOf(response.status) !== -1) {
      console.log("AUTH ERROR!");
      throw new Error("Unautorized");
    }
  }
  throw new Error("Network response was not ok.");
}

